import React from 'react'
import Pt from 'prop-types'

// Polyfill webpack require.ensure for tests
/* istanbul ignore else */
if (typeof require.ensure !== 'function') {
  require.ensure = (d, c) => c(require)
}

/**
 * Calculates a zxcvbn result for a given value prop, and passes
 * it as strength to the WrappedComponent.
 */
export default function withPasswordStrength(WrappedComponent) {
  return class PasswordStrength extends React.Component {
    static displayName = `withPasswordStrength(${WrappedComponent.displayName || WrappedComponent.name})`
    static propTypes = {
      // eslint-disable-next-line react/forbid-prop-types
      value: Pt.any,
      zxcvbn: Pt.func,
    }

    state = {
      loading: false,
      result: undefined,
    }

    zxcvbn = null

    componentWillMount() {
      if (!this.props.zxcvbn) {
        this.setState({ loading: true })

        require.ensure(['zxcvbn'], (require) => {
          this.zxcvbn = require('zxcvbn')
          this.setState({
            loading: false,
            result: this.calculateResult(this.props.value),
          })
        })
      } else {
        this.setState({
          result: this.calculateResult(this.props.value),
        })
      }
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          result: this.calculateResult(nextProps.value),
        })
      }
    }

    componentWillUnmount() {
      this.zxcvbn = undefined
    }

    calculateResult = (password) => {
      if (!password) {
        return undefined
      }

      if (this.props.zxcvbn) {
        return this.props.zxcvbn(password)
      }

      if (this.zxcvbn) {
        return this.zxcvbn(password)
      }

      /* istanbul ignore next */
      return undefined
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          strength={this.state.result}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/Form/withPasswordStrength.jsx